import React, { useEffect } from "react";
import "./SmoothScrollSection.css";
import welcomeImage from "../../images/brandinchi-1.webp";

const SmoothScrollSection: React.FC = () => {
  useEffect(() => {
    const handleClick = (event) => {
      event.preventDefault();
      const targetElement = document.getElementById("next");
      if (targetElement) {
        window.scrollTo({
          top: targetElement.offsetTop,
          behavior: "smooth",
        });
      }
    };

    const mouseElement = document.querySelector(".mouse.smoothscroll");
    if (mouseElement) {
      mouseElement.addEventListener("click", handleClick);
    }

    return () => {
      if (mouseElement) {
        mouseElement.removeEventListener("click", handleClick);
      }
    };
  }, []);
  return (
    <section
      className="site-hero overlay"
      style={{ backgroundImage: `url(${welcomeImage})` }}
      data-stellar-background-ratio="0.5"
    >
      <a className="mouse smoothscroll" href="#next">
        <div className="mouse-icon">
          <span className="mouse-wheel"></span>
        </div>
      </a>
      <div className="image-caption">Cala Brandinchi</div>
    </section>
  );
};

export default SmoothScrollSection;
